/**
 * Hyper-V enlightenments shown in the VM form's enlightenments dialog.
 *
 * Kept free of imports so its unit test can load the compiled module directly.
 */

export interface VmEnlightenmentConfig {
  hv_compat: boolean;
  hv_enlightenments: string[];
}

/**
 * The enlightenments to show ticked when the dialog opens: exactly what the
 * VM runs with, so an unenlightened VM shows an empty list (#228).
 *
 * - A new VM: the recommended set, which the create writes into its config
 *   unless the dialog sends another list.
 * - A VM with its own list: that list.
 * - An hv_compat VM without one: the recommended set, which build_cpu_args
 *   gives it.
 * - Otherwise: none.
 *
 * @param vm    the VM being modified, or null in the create form
 * @param sets  the preset sets from the options endpoint
 */
export function enlightenmentsToShow(
  vm: VmEnlightenmentConfig | null,
  sets: Record<string, string[]>,
): string[] {
  if (vm === null) return sets.recommended;
  if (vm.hv_enlightenments.length > 0) return vm.hv_enlightenments;
  if (vm.hv_compat) return sets.recommended;
  return [];
}
